<template>
  <b-table
    :data="items"
    :mobile-cards="false"
    narrowed
    sticky-header
    :row-class="rowClass"
    :height="height"
  >
    <b-table-column label="" width="40" centered v-slot="props">
      <b-tooltip v-show="props.row.error" position="is-right">
        <b-icon icon="information" type="is-danger"></b-icon>
        <template v-slot:content>
          {{ props.row.error }}
        </template>
      </b-tooltip>
    </b-table-column>
    <b-table-column
      field="code"
      :label="$t('attributes.group_code')"
      width="100"
      centered
      sortable
      v-slot="props"
    >
      <b-tooltip type="is-light" position="is-right">
        <p>{{ props.row.code }}</p>
        <template v-slot:content>
          <p v-html="props.row.name"></p>
        </template>
      </b-tooltip>
    </b-table-column>
    <b-table-column
      field="departure_date"
      :label="$t('attributes.departure_date')"
      width="100"
      sortable
      centered
      v-slot="props"
    >
      {{ formatDate(props.row.departure_date) }}
    </b-table-column>
    <b-table-column :label="$t('attributes.group_name')" v-slot="props">
      <b-input
        :ref="`name-input-${props.row.code}`"
        type="textarea"
        rows="2"
        v-show="props.row.editing"
        v-model="props.row.nameValue"
        @keypress.enter.exact.native.prevent="
          finish(props.row, props.index + 1)
        "
        @keypress.enter.shift.exact.native.prevent="
          finish(props.row, props.index - 1)
        "
        @keydown.esc.exact.native.prevent="cancel(props.row)"
        @input="value => changeName(props.row, value)"
      />
      <div
        v-show="!props.row.editing"
        v-html="props.row.name"
        @click.meta="editing(props.row)"
        @click.shift="editing(props.row)"
      ></div>
    </b-table-column>
    <b-table-column
      width="120"
      :label="$t('attributes.function')"
      centered
      v-slot="props"
    >
      <div class="buttons is-centered">
        <b-button
          v-if="!props.row.editing"
          type="is-info"
          icon-left="pencil"
          @click.prevent="editing(props.row)"
        >
        </b-button>
        <b-tooltip :label="$t('attributes.restore')">
          <b-button
            v-if="!props.row.editing"
            type="is-info"
            icon-left="restore"
            outlined
            @click.prevent="restore(props.row)"
          >
          </b-button>
        </b-tooltip>
        <b-button
          v-if="props.row.editing"
          type="is-success"
          icon-left="check"
          @click.prevent="finish(props.row)"
        >
        </b-button>
        <b-button
          v-if="props.row.editing"
          type="is-dark"
          icon-left="close"
          outlined
          @click.prevent="cancel(props.row)"
        >
        </b-button>
      </div>
    </b-table-column>

    <template #empty>
      <section class="section" style="height: 100%">
        <div v-if="!loading" class="content has-text-grey has-text-centered">
          <p>
            <b-icon icon="emoticon-sad" size="is-large" />
          </p>
        </div>
      </section>
    </template>
  </b-table>
</template>

<script>
export default {
  name: 'BatchNameTable',

  props: {
    groups: {
      Type: Array,
      required: true
    },
    height: Number,
    loading: Boolean
  },
  data() {
    return {
      items: this.extractGroups(this.groups)
    }
  },
  watch: {
    groups(list) {
      this.items = this.extractGroups(list)
    }
  },
  methods: {
    extractGroups(groups) {
      return groups.map(group => ({
        code: group.code,
        departure_date: group.departure_date,
        nameValue: group.name,
        name: group.name,
        editing: false,
        dirty: false,
        error: null,
        origin: group
      }))
    },
    changeName(group, name) {
      group.nameValue = name.replace(/\n/g, '')
    },
    editing(group) {
      setTimeout(() => {
        const textarea = this.$refs[`name-input-${group.code}`].getElement()
        if (textarea) {
          textarea.selectionStart = 0
          textarea.selectionEnd = 0
          textarea.focus()
        }
      }, 0)

      group.editing = true
    },
    finish(group, next) {
      group.name = group.nameValue
      group.dirty = group.origin.name !== group.name
      group.editing = false

      this.validate(group)

      let index = (next + this.items.length) % this.items.length
      if (index >= 0 && index < this.items.length) {
        const nextGroup = this.items[index]
        this.editing(nextGroup)
      }
    },
    cancel(group) {
      group.nameValue = group.name
      group.dirty = group.origin.name !== group.name
      group.editing = false
    },
    restore(group) {
      group.name = group.origin.name
      group.nameValue = group.origin.name
      group.dirty = false
      group.error = null
      group.editing = false
    },
    isDirty() {
      return this.items.filter(x => x.dirty).length > 0
    },
    isEditing() {
      return this.items.filter(x => x.editing).length > 0
    },
    isValidate() {
      for (const group of this.items) {
        if (!this.validate(group)) {
          return false
        }
      }

      return true
    },
    validate(group) {
      if (!group.name.trim()) {
        group.error = '名稱不可空白'
        return false
      }

      group.error = null
      return true
    },
    getData() {
      return this.items
        .filter(group => group.dirty)
        .map(group => ({
          code: group.code,
          name: group.name
        }))
    },
    rowClass(group) {
      if (group.error) {
        return 'has-background-danger-light'
      } else if (group.dirty) {
        return 'has-background-warning'
      } else {
        return null
      }
    }
  }
}
</script>

<style scoped></style>
